module.exports = {
  'en': {
    'HRMS27UC1': {
      '1': 'Personnel req. no.',
      '10': 'for Position',
      '20': 'Apply date from',
      '30': 'To',
      '40': 'Applicant No.',
      '50': 'Name',
      '60': 'Applied Date',
      '70': 'Applied for Position',
      '80': 'Status',
      '90': 'P.R No.',
      '99': 'Confirm selection for Interview',
      '100': 'Position',
      '110': 'Order',
      '120': 'List of selected candidate',
      '130': 'Recruiter name',
      '140': 'Interview date'
    },
    'HRMS27UC2': {
      '10': 'Detail Approve',
      '20': 'Approve By',
      '30': 'Date Approve',
      '40': 'Status Approve',
      '50': 'Approve',
      '60': 'Not Approve',
      '70': 'Remark approve'
    }
  },
  'th': {
    'HRMS27UC1': {
      '1': 'เลขที่ใบขออนุมัติ',
      '10': 'สำหรับตำแหน่ง',
      '20': 'วันที่สมัครตั้งแต่',
      '30': 'ถึง',
      '40': 'เลขที่ใบสมัคร',
      '50': 'ชื่อ - นามสกุล',
      '60': 'วันที่สมัคร',
      '70': 'สมัครตำแหน่ง',
      '80': 'สถานะ',
      '90': 'เลขที่ใบขอ',
      '99': 'การยืนยันการคัดเลือกผู้สมัครเพื่อนัดหมายเรียกสัมภาษณ์',
      '100': 'ตำแหน่ง',
      '110': 'ลำดับที่',
      '120': 'รายชื่อที่ได้รับการคัดเลือก',
      '130': 'ผู้รับสมัคร',
      '140': 'วันที่นัดสัมภาษณ์'
    },
    'HRMS27UC2': {
      '10': 'รายละเอียดการอนุมัติ',
      '20': 'อนุมัติโดย',
      '30': 'วันที่อนุมัติ',
      '40': 'สถานะการอนุมัติ',
      '50': 'อนุมัติ',
      '60': 'ไม่อนุมัติ',
      '70': 'หมายเหตุการอนุมัติ'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms27u.js